import { useTheme } from '@mui/material';

import { CustomIcon } from 'modules/components/layer00';
import { SaveDeliveryForm } from 'modules/components/layer12';
import { BasicFormModalLayout } from 'modules/components/layer13';

import { useParams } from 'react-router-dom';


export type SaveDeliveryModalProps = {
  id: string;
  isVisible: boolean;
  handleClose: () => void;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: SaveDeliveryModalProps) => {
  const params = useParams();
  const theme = useTheme();
  return (
    <BasicFormModalLayout.FC
      id={props.id}
      handleClose={() => props.handleClose()}
      isVisible={props.isVisible}
      title='Delivery'
      subTitle='Log Delivery Information'
      headerIcon={(
        <CustomIcon.large.FC
          icon='DELIVERY'
          stroke={theme.palette.primary.main}
        />
      )}
    >
      <SaveDeliveryForm.FC
        handleClose={props.handleClose}
        id={props.id}
        projectId={params.projectId}
        installationId={params.installationId}
      />

    </BasicFormModalLayout.FC>
  );
};
